import i18n from "site/services/exercise-stage-i18n.json";
import { normalizeUiLang, type UiLang } from "site/services/i18n";

type StageCopy = {
  description?: string;
  button?: string;
};

type StepStages = Record<string, StageCopy>;

const copyByLang = i18n as Record<UiLang, Record<string, StepStages>>;

function stageCopy(stepKey: string | null | undefined, stageKey: string | null | undefined, lang: UiLang): StageCopy | null {
  const normalizedStep = String(stepKey ?? "").trim();
  const normalizedStage = String(stageKey ?? "").trim();
  if (!normalizedStep || !normalizedStage) {
    return null;
  }
  return copyByLang[lang]?.[normalizedStep]?.[normalizedStage] ?? null;
}

export function exerciseStageDescription(
  stepKey: string | null | undefined,
  stageKey: string | null | undefined,
  lang?: string | null,
): string {
  const uiLang = normalizeUiLang(String(lang ?? "ru"));
  const primary = stageCopy(stepKey, stageKey, uiLang)?.description?.trim();
  if (primary) {
    return primary;
  }
  if (uiLang !== "ru") {
    return stageCopy(stepKey, stageKey, "ru")?.description?.trim() ?? "";
  }
  return "";
}

export function exerciseStageButton(
  stepKey: string | null | undefined,
  stageKey: string | null | undefined,
  lang?: string | null,
): string {
  const uiLang = normalizeUiLang(String(lang ?? "ru"));
  const primary = stageCopy(stepKey, stageKey, uiLang)?.button?.trim();
  if (primary) {
    return primary;
  }
  if (uiLang !== "ru") {
    return stageCopy(stepKey, stageKey, "ru")?.button?.trim() ?? "";
  }
  return "";
}

export function exerciseStageHasButton(stepKey: string | null | undefined, stageKey: string | null | undefined): boolean {
  return !!exerciseStageButton(stepKey, stageKey, "ru");
}
